export const iniState = {
  showAddEndDate: true
};

export const reducers = {};
